import React from 'react';
import { Provider } from 'react-redux';
import { setupStore } from '../../store/store';

type TAppStoreProvider = {
  children: React.ReactNode;
};

const store = setupStore();

export const AppStoreProvider = ({ children }: TAppStoreProvider) => {
  return <Provider store={store}>{children}</Provider>;
};